import { render, staticRenderFns } from "./setFioPage.vue?vue&type=template&id=76f938b4&scoped=true"
import script from "./setFioPage.vue?vue&type=script&lang=js"
export * from "./setFioPage.vue?vue&type=script&lang=js"
import style0 from "./setFioPage.vue?vue&type=style&index=0&id=76f938b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f938b4",
  null
  
)

export default component.exports